import { useMemo, useState } from 'react'
import { trpc } from 'api'
import { useCustomer } from './useSession'

const isRecent = (created_date: string) => {
  // "2020-01-01 10:10:10"
  // const today = new Date().toISOString().split('T')[0]
  // return = created_date.includes(today)

  const now = new Date()
  const created = new Date(`${created_date.replace(' ', 'T')}.000Z`)

  const diff = now.getTime() - created.getTime()
  const diffDays = diff / (1000 * 3600 * 24)

  return diffDays <= 1
}

export default function useRecentPrescription() {
  const customer = useCustomer()
  const { data } = trpc.customer.prescriptions.list.useQuery(
    {
      limit: 1,
      id: customer?.id || 0,
    },
    {
      enabled: !!customer?.id,
    }
  )
  const prescriptions = data?.data

  const hasRecent = useMemo(() => {
    if (!prescriptions) return false

    const latest = prescriptions?.[0]
    if (latest) {
      return isRecent(latest.create_date)
    }
    return false
  }, [prescriptions])

  return hasRecent
}
